import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth, routeAfterAuth } from "../lib/auth";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const nav = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const tick = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          // Pull fresh user (now has plan_selected_at) and bounce to next step
          const u = await refresh();
          if (u) {
            const target = u.has_wedding ? "/dashboard" : "/onboarding";
            setTimeout(() => nav(target, { replace: true }), 1500);
          }
          return;
        }
        if (data.status === "expired") {
          setStatus("expired");
          return;
        }
        if (++attempts < 20) setTimeout(tick, 2000);
        else setStatus("timeout");
      } catch {
        if (++attempts < 20) setTimeout(tick, 2000);
        else setStatus("timeout");
      }
    };
    tick();
  }, [sessionId, refresh, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-warm)] px-6">
      <div className="max-w-md text-center">
        {status === "polling" && (
          <>
            <Loader2 className="w-10 h-10 mx-auto text-[var(--gold)] animate-spin mb-6" />
            <h1 className="font-serif font-light text-3xl mb-3">Confirming your subscription…</h1>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[var(--gold)] flex items-center justify-center"><Check className="w-8 h-8 text-white" /></div>
            <p className="font-script text-[var(--gold)] text-4xl">Welcome to luxury</p>
            <h1 className="font-serif font-light text-4xl mt-2 mb-4">Your plan is active</h1>
            <Link to="/dashboard" className="btn-gold mt-4">Open Dashboard</Link>
          </>
        )}
        {(status === "expired" || status === "timeout") && (
          <>
            <h1 className="font-serif text-3xl mb-3">Hmm, that didn't go through</h1>
            <Link to="/pricing" className="btn-gold mt-4">Try again</Link>
          </>
        )}
      </div>
    </div>
  );
}
